const FEATURE_FLAGS = {
  localization: "cross_localization",
  extractFlightAI: "fe_ud_ai_extract_flight",
  eventTheming: "cross_event_theming_enabled",
};

export default FEATURE_FLAGS;
